import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

import { MasterService } from 'src/app/services/master.service';

@Injectable()
export class PaymentChannelsResolver implements Resolve<any> {
  constructor(private masterService: MasterService) {}

  public resolve() {

    return this.masterService
      .getPaymentChannels()
      .toPromise()
      .then((result: any) => {
        return result.data || [];
      })
      .catch(error => {
        return [];
      });
  }
}
